<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    return-object
    item-text="name"
    item-value="id"
    :items="buses"
    @change="onChange"
    v-on:input="$emit('input', $event)"
    @update:search-input="update"
    clearable
    :loading="loading"
  ></v-autocomplete>
</template>

<script>
// import { mapGetters } from 'vuex'
import { Bus } from '@/plugins/api'

export default {
  data: () => ({
    loading: false,
    buses: []
  }),
  props: {
    filters: Object
  },
  computed: {},
  async created() {
    await this.fetchAllBuses()
  },
  methods: {
    async fetchAllBuses(query) {
      this.loading = true
      const params = {
        ...query,
        _limit: -1
      }
      this.buses = await Bus.fetch(params)
      this.loading = false
    },
    async update(data) {},
    onChange(data) {
      this.$emit('change', data)
    }
  }
}
</script>
